export function USER_REQUEST(state) {
  state;
  state.adminAndStaff = {
    ...state.adminAndStaff,
    isLoading: true
  };
}
export function USER_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.internalUsers.rows.map(item => {
    data.push({
      id: item.userId || "-",
      username: item.username || "-",
      fullname: item.fullname || "-",
      userType: item.userType || "-",
      isActive: item.isActive
    });
    return item;
  });
  state;
  state.adminAndStaff = {
    data: data,
    count: payload.data.data.internalUsers.count,
    status: payload.status,
    isLoading: false
  };
}
export function USER_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_USER_REQUEST(state) {
  state;
  state.adminOrStaff = {
    ...state.adminOrStaff,
    isLoading: true
  };
}
export function GET_USER_SUCCESS(state, payload) {
  const { internalUsers } = payload.data.data;
  const data = {
    id: internalUsers.userId || "-",
    username: internalUsers.username || "",
    password: internalUsers.password || "",
    fullname: internalUsers.fullname || "",
    jobTitle: internalUsers.jobTitle || "",
    roleId: internalUsers.userRoles[0].roleId || "",
    isActive: internalUsers.isActive || "",
    userCreated: internalUsers.userCreated || "",
    email: internalUsers.email || "",
    userType: internalUsers.roleName || "",
    branchCode: internalUsers.internalUserBranches[0].branch_code || "",
    primarySalesrepId: internalUsers.primarySalesrepId || "",
  };
  state;
  state.adminOrStaff = {
    isLoading: false,
    data: data
  };
}
export function GET_USER_ERROR(state, payload) {
  state;
  state.adminOrStaff = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_USER_REQUEST(state) {
  state;
  state.adminOrStaff = {
    ...state.adminOrStaff,
    isLoading: true
  };
}
export function CREATE_USER_SUCCESS(state, payload) {
  state;
  state.adminAndStaff = {
    isLoading: false,
    data: [...state.adminAndStaff.data, payload.data],
    status: payload.status
  };
  state.adminOrStaff = {
    ...state.adminOrStaff,
    isLoading: false
  };
}
export function CREATE_USER_ERROR(state, payload) {
  state;
  state.adminAndStaff = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function EDIT_USER_REQUEST(state) {
  state;
  state.adminOrStaff = {
    ...state.adminOrStaff,
    isLoading: true
  };
}
export function EDIT_USER_SUCCESS(state) {
  state;
  state.adminOrStaff = {
    ...state.adminOrStaff,
    isLoading: false
  };
}
export function EDIT_USER_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function DELETE_USER_REQUEST(state) {
  state;
  state.adminAndStaff = {
    ...state.adminAndStaff,
    isLoading: true
  };
}
export function DELETE_USER_SUCCESS(state, payload) {
  let index = state.adminAndStaff.data.findIndex(item => item.id == payload);
  state.adminAndStaff.data.splice(index, 1);
  state;
  state.adminAndStaff = {
    ...state.adminAndStaff,
    isLoading: false,
    data: state.adminAndStaff.data
  };
}
export function DELETE_USER_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
